/*eslint-disable */
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let ZohoApis = {
  /**
   * zohoInvoiceGenerate
   */
  async zohoInvoiceGenerate (context, payloadObj=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();  
      for (let key in payloadObj) {
        if(payloadObj[key] || typeof payloadObj[key] == 'number') {
          post_data.append(key, payloadObj[key])
        }
      }

      return await request.curl(context, "zoho_invoice_generate", post_data)
      .then(async response => {
        return response
      });
    }
    catch(err){
      console.error('Exception occurred at zohoInvoiceGenerate() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  }
}

export {
  ZohoApis
}